import { NavLink } from "react-router-dom";
import { Menu as MenuIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { useI18n } from "@/i18n";

/** Barra di navigazione in basso: sul telefono le pagine più usate restano a portata di pollice. */
export const MobileNav = ({ items, onMore }) => {
  const { t } = useI18n();

  // Etichette corte: "Sala & Tavoli" → "Sala", "Écrans des postes" → "Écrans"
  const short = (s) => {
    const a = s.split(" & ")[0];
    return a.length > 12 ? a.split(" ")[0] : a;
  };

  return (
    <nav
      data-testid="mobile-nav"
      className="fixed bottom-0 left-0 right-0 z-50 flex border-t border-slate-200 bg-white/95 pb-[env(safe-area-inset-bottom)] backdrop-blur lg:hidden"
    >
      {items.map((n) => (
        <NavLink
          key={n.id}
          to={n.to}
          end={n.to === "/"}
          data-testid={`mobilenav-${n.id}`}
          className={({ isActive }) =>
            cn("flex min-h-[56px] flex-1 flex-col items-center justify-center gap-1 px-1 py-2 text-[10px] font-semibold transition-colors",
              isActive ? "text-slate-900" : "text-slate-400")
          }
        >
          {({ isActive }) => (
            <>
              <n.icon className={cn("h-5 w-5", isActive && "text-amber-500")} />
              <span className="max-w-full truncate">{short(t(n.labelKey))}</span>
            </>
          )}
        </NavLink>
      ))}
      <button
        onClick={onMore}
        data-testid="mobilenav-more"
        className="flex min-h-[56px] flex-1 flex-col items-center justify-center gap-1 px-1 py-2 text-[10px] font-semibold text-slate-400"
      >
        <MenuIcon className="h-5 w-5" />
        <span className="max-w-full truncate">{t("nav.more")}</span>
      </button>
    </nav>
  );
};
